import { DropOverlay } from "@/components/common/DropOverlay/DropOverlay"
import { toast } from "@/components/common/Toast"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useUploadFormats } from "@/services/api/uploadFormatsService"

interface KnowledgebaseDropOverlayProps {
  onFilesDropped: (files: File[]) => void
  isDisabled?: boolean
}

export const KnowledgebaseDropOverlay: React.FC<
  KnowledgebaseDropOverlayProps
> = ({ onFilesDropped, isDisabled = false }) => {
  const { translate } = useTranslation()
  // Backend-authored list (`services/upload_formats.py`, served by
  // GET /upload-formats) rather than a local constant — this is the drift the
  // shared list exists to remove. The API itself has no server-side gate for
  // knowledge_base (accepts anything it is handed); this list is a picker-only
  // curation, and it already excludes `.xls` on the backend side, so nothing
  // is lost by reading it from there instead of restating it here.
  const uploadFormats = useUploadFormats()
  const acceptedExtensions = uploadFormats.destinations.knowledge_base.extensions

  if (isDisabled) return null

  return (
    <DropOverlay
      acceptedExtensions={acceptedExtensions}
      hint={translate("KNOWLEDGEBASE/DROP_OVERLAY_HINT")}
      onFilesDropped={onFilesDropped}
      onRejectedFiles={() =>
        toast.error(translate("KNOWLEDGEBASE/TOAST_UNSUPPORTED_FILE_FORMAT"))
      }
    />
  )
}
